import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c18ecce"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "basic",
  ref: "basic"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "基本资料", -1);
});

var _hoisted_3 = {
  class: "row"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "空间ID", -1);
});

var _hoisted_5 = {
  class: "value notEditable"
};
var _hoisted_6 = {
  class: "row"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "空间名称", -1);
});

var _hoisted_8 = {
  key: 0,
  class: "value spaceNameValue"
};
var _hoisted_9 = {
  class: "row",
  ref: "manageRow"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "空间全局管理员", -1);
});

var _hoisted_11 = {
  class: "manager-tip"
};
var _hoisted_12 = {
  class: "value managerValue"
};
var _hoisted_13 = {
  key: 0,
  class: "row"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("保存");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("取消");

import { ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import CompanyService from '@/api/company';
import userMemberSearch from '../Components/userMemberSearch.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var store = useStore();
    var isEdit = ref(false);
    var editItem = reactive({
      id: '',
      name: 0,
      globalAdminList: []
    });
    var spaceDetail = computed(function () {
      return store.state.company.spaceDetail;
    });
    var corporationId = computed(function () {
      var _route$params$company;

      return ((_route$params$company = route.params.company_id) === null || _route$params$company === void 0 ? void 0 : _route$params$company.toString()) || '';
    });
    var hasEditAuth = computed(function () {
      return store.state.company.hasEditAuth;
    });

    var edit = function edit() {
      isEdit.value = true;
      Object.keys(spaceDetail.value).forEach(function (key) {
        editItem[key] = spaceDetail.value[key];
      });
    };

    var userSelectedList = computed(function () {
      return editItem.globalAdminList.map(function (item) {
        return {
          user_name: item.name,
          user_id: item.id
        };
      });
    });

    var checkBusiName = function checkBusiName() {
      var _editItem$name;

      if (!editItem.name) {
        ElMessage({
          message: '空间名称不可为空',
          type: 'error'
        });
        return false;
      }

      if (((_editItem$name = editItem.name) === null || _editItem$name === void 0 ? void 0 : _editItem$name.trim().length) > 20) {
        ElMessage({
          message: '空间名称不可超过20字符',
          type: 'error'
        });
        return false;
      }

      return true;
    };

    var checkManager = function checkManager() {
      var _editItem$globalAdmin;

      if (!(((_editItem$globalAdmin = editItem.globalAdminList) === null || _editItem$globalAdmin === void 0 ? void 0 : _editItem$globalAdmin.length) > 0)) {
        ElMessage({
          message: '全局管理员不可为空',
          type: 'error'
        });
        return false;
      }

      return true;
    }; // 修改企业信息


    var updateCompanyInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _editItem$globalAdmin2, _data$data, globalAdmins, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(checkBusiName() && checkManager())) {
                  _context.next = 7;
                  break;
                }

                globalAdmins = '';

                if (((_editItem$globalAdmin2 = editItem.globalAdminList) === null || _editItem$globalAdmin2 === void 0 ? void 0 : _editItem$globalAdmin2.length) > 0) {
                  globalAdmins = editItem.globalAdminList.map(function (item) {
                    return item.id;
                  }).join(',');
                }

                _context.next = 5;
                return CompanyService.updateBusi({
                  appGroup: 'beacon',
                  bizId: route.params.biz_url,
                  bizName: editItem.name,
                  globalAdmins: globalAdmins
                });

              case 5:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  ElMessage({
                    message: '修改空间信息成功',
                    type: 'success'
                  });
                  store.dispatch('company/getSpaceDetail', {
                    bizId: route.params.biz_url,
                    appGroup: 'beacon'
                  });
                  isEdit.value = false;
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function updateCompanyInfo() {
        return _ref.apply(this, arguments);
      };
    }();

    var updateUserList = function updateUserList(list) {
      editItem.globalAdminList = list.map(function (item) {
        return {
          id: item.user_id,
          name: item.user_name
        };
      });
    };

    onMounted(function () {
      var _route$params$company2;

      corporationId.value = ((_route$params$company2 = route.params.company_id) === null || _route$params$company2 === void 0 ? void 0 : _route$params$company2.toString()) || '';
      store.dispatch('company/getManagerList', {
        corporation_id: corporationId.value
      });
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(spaceDetail).id || ''), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, !isEdit.value ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(spaceDetail).name || ''), 1)) : (_openBlock(), _createBlock(_component_el_input, {
        key: 1,
        autocomplete: "off",
        class: "custom-input",
        modelValue: _unref(editItem).name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(editItem).name = $event;
        })
      }, null, 8, ["modelValue"]))]), _createElementVNode("div", _hoisted_9, [_hoisted_10, !isEdit.value ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        teleported: false,
        placement: "top"
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spaceDetail).globalAdminList, function (item, index) {
            return _openBlock(), _createElementBlock("span", {
              key: item
            }, _toDisplayString(index !== 0 ? '; ' : '') + _toDisplayString(item.name), 1);
          }), 128))])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spaceDetail).globalAdminList, function (item, index) {
            return _openBlock(), _createElementBlock("span", {
              key: item
            }, _toDisplayString(index !== 0 ? '; ' : '') + _toDisplayString(item.name), 1);
          }), 128))])];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(userMemberSearch, {
        key: 1,
        style: {
          "width": "418px"
        },
        userSelectedList: _unref(userSelectedList),
        corporationId: _unref(corporationId),
        onUpdateUserList: updateUserList
      }, null, 8, ["userSelectedList", "corporationId"]))], 512), _unref(hasEditAuth) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [!isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "primary-button edit-info",
        type: "primary",
        onClick: edit
      }, {
        default: _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      })) : _createCommentVNode("", true), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "primary-button save",
        type: "primary",
        onClick: updateCompanyInfo
      }, {
        default: _withCtx(function () {
          return [_hoisted_15];
        }),
        _: 1
      })) : _createCommentVNode("", true), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "normal-button cancel",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return isEdit.value = false;
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512);
    };
  }
});